/**
 * Returns a function that as long as it continues to be invoked, won't be triggered.
 * @param {Function} fn - Callback function.
 * @param {number} [wait=300] - Delay (in milliseconds).
 * @returns {Function}
 */
function debounce(fn, wait = 300) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

if (!customElements.get('announcement-bar')) {
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('.announcement__slider');
      this.localization = this.querySelector('.announcement__localization');
      this.links = this.querySelectorAll('.js-announcement-link');
      this.menu = document.querySelector('.main-menu__content');

      this.bindEvents();
      this.init();
    }

    disconnectedCallback() {
      clearInterval(this.rotationTimer);
      if (this.moveLinksHandler) {
        window.removeEventListener('on:breakpoint-change', this.moveLinksHandler);
      }

      if (this.moveLocalizationHandler) {
        window.removeEventListener('on:breakpoint-change', this.moveLocalizationHandler);
      }
    }

    bindEvents() {
      if (this.links) {
        this.moveLinksHandler = this.moveLinksHandler || this.moveLinks.bind(this);
        window.addEventListener('on:breakpoint-change', this.moveLinksHandler);
      }

      if (this.localization) {
        this.moveLocalizationHandler = this.moveLocalizationHandler
          || debounce(this.moveLocalization.bind(this));
        window.addEventListener('on:breakpoint-change', this.moveLocalizationHandler);
      }


    }

    /**
     * Start sliders a slidin'
     */
    init() {
      if (this.slider) {
        this.slides = [...this.slider.querySelectorAll('.announcement__text')];
        this.currentSlide = 0;
        this.updateSlides();
        this.querySelectorAll('[data-announcement-direction]').forEach((button) => {
          button.addEventListener('click', () => {
            const direction = Number(button.dataset.announcementDirection);
            this.currentSlide = (this.currentSlide + direction + this.slides.length) % this.slides.length;
            const left = this.currentSlide * this.slider.clientWidth * (document.dir === 'rtl' ? -1 : 1);
            this.slider.scrollTo({
              left,
              behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
            });
            this.updateSlides();
          });
        });
        this.rotationTimer = setInterval(() => {
          if (this.slides.length < 2 || document.hidden || this.matches(':hover') || this.contains(document.activeElement)
            || window.matchMedia('(prefers-reduced-motion: reduce)').matches || !theme.elementUtil.isInViewport(this)) return;
          this.currentSlide = (this.currentSlide + 1) % this.slides.length;
          this.slider.scrollTo({
            left: this.currentSlide * this.slider.clientWidth * (document.dir === 'rtl' ? -1 : 1),
            behavior: 'smooth'
          });
          this.updateSlides();
        }, Number(this.dataset.slideDelay) || 7000);
        this.slider.addEventListener('scroll', debounce(() => {
          this.currentSlide = Math.min(this.slides.length - 1, Math.round(Math.abs(this.slider.scrollLeft) / this.slider.clientWidth));
          this.updateSlides();
        }, 100));
      }

      if (this.links) {
        this.moveLinks();
      }

      if (this.localization) {
        this.moveLocalization();
      }
    }

    /**
     * Move the help links selectors to the mobile nav/back to the announcement bar if necessary
     */
    moveLinks() {
      const menuAnnouncementLinks = document.querySelector('.mob__announcement-links');
      if (!theme.mediaMatches.md && !menuAnnouncementLinks) {
        // Move localization to mobile
        const mobNav = document.createElement('nav');
        mobNav.classList.add('mob__announcement-links');

        const mobNavUl = document.createElement('ul');
        mobNav.classList.add('secondary-nav');

        this.links.forEach((link) => {
          mobNav.innerHTML += `<li><a class="secondary-nav__item" href="${link.href}">${link.innerText}</a>`;
        });

        mobNav.appendChild(mobNavUl);
        this.menu.appendChild(mobNav);
      } else if (theme.mediaMatches.md && menuAnnouncementLinks) {
        menuAnnouncementLinks.remove();
      }
    }

    /**
     * Move the localization selectors to the mobile nav/back to the announcement bar if necessary
     */
    moveLocalization() {
      this.slider = this.querySelector('.announcement__slider');
      this.localization = this.querySelector('.announcement__localization');
      this.links = this.querySelectorAll('.js-announcement-link');
      this.menu = document.querySelector('.main-menu__content');
      const menuLocalization = document.querySelector('.mob__localization');
      if (!theme.mediaMatches.md && !menuLocalization) {
        // Move localization to mobile
        const mobLocalizationElem = document.createElement('div');
        mobLocalizationElem.classList.add('mob__localization');
        mobLocalizationElem.appendChild(this.localization.firstElementChild);
        this.menu.appendChild(mobLocalizationElem);
      } else if (theme.mediaMatches.md && menuLocalization) {
        // Move localization back to announcement bar
        this.localization.appendChild(menuLocalization.firstElementChild);
        menuLocalization.remove();
      }
    }

    updateSlides() {
      this.slides.forEach((slide, index) => {
        const active = index === this.currentSlide;
        slide.classList.toggle('is-visible', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
      });
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);
}
